import MuiAccordionDetails, { AccordionDetailsProps as MuiAccordionDetailsProps } from '@mui/material/AccordionDetails';
import * as React from 'react';

export interface AccordionDetailProps extends MuiAccordionDetailsProps {}

export const AccordionDetails = (props: AccordionDetailProps) => {
  return <MuiAccordionDetails {...props} />;
};
